import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import { useTranslation } from 'react-i18next';
import React from 'react';

import { actions, useDispatch, useSelector } from '@/redux';
import { codePushChannels } from '@/configs/codePush';
import CenterModal from '@/components/Modals/CenterModal';

import { dialogNames } from './constants';

const CodePushChannelDialog = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isOpen = useSelector(state => state.app.dialogs.codePushChannel.open);

  const handleClose = () => {
    dispatch(actions.app.toggleDialog(dialogNames.codePushChannel, false));
  };

  return (
    <CenterModal
      visible={isOpen}
      enablePressOutsideClose
      title={t('app.dialogs.codePushChannel.title')}
      containerStyle={{ width: '80%' }}
      contentContainerStyle={styles.container}
      onClose={handleClose}
    >
      {codePushChannels.map(depl => {
        return (
          <TouchableOpacity
            key={depl}
            style={styles.button}
            onPress={async () => {
              await dispatch(actions.codePush.overwriteDeployment(depl));
              dispatch(actions.codePush.checkUpdate());
              dispatch(actions.app.toggleDialog(dialogNames.codePushProgress, true));
              handleClose();
            }}
          >
            <Text style={{ fontSize: 20 }}>{depl}</Text>
          </TouchableOpacity>
        );
      })}
    </CenterModal>
  );
};

const styles = StyleSheet.create({
  container: {
    minWidth: '80%',
    maxWidth: 450,
  },
  buttonContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  button: {
    margin: 12,
    width: '100%',
    paddingVertical: 4,
    alignItems: 'center',
  },
  input: {
    borderWidth: 1,
    padding: 12,
    margin: 20,
    width: '100%',
  },
});

export default CodePushChannelDialog;
